import { render, staticRenderFns } from "./FaceDetector.vue?vue&type=template&id=23a4fa6c&scoped=true&"
import script from "./FaceDetector.vue?vue&type=script&lang=js&"
export * from "./FaceDetector.vue?vue&type=script&lang=js&"
import style0 from "./FaceDetector.vue?vue&type=style&index=0&id=23a4fa6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a4fa6c",
  null
  
)

export default component.exports